import { render, staticRenderFns } from "./RouteBreadcrumb.vue?vue&type=template&id=252a2e7a&scoped=true&"
import script from "./RouteBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./RouteBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./RouteBreadcrumb.vue?vue&type=style&index=0&id=252a2e7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252a2e7a",
  null
  
)

export default component.exports